import cx from 'classnames';
import { HTMLAttributes } from 'react';

interface TextProps {
  textAlignment?: 'CENTER';
}

export const Text = {
  H1: ({
    textAlignment,
    className,
    children,
    ...props
  }: TextProps & HTMLAttributes<HTMLHeadingElement>) => (
    <h1
      {...props}
      className={cx(
        'text-4xl md:text-5xl font-semibold text-gray-800 leading-snug',
        textAlignment === 'CENTER' && 'text-center',
        className,
      )}
    >
      {children}
    </h1>
  ),
  H2: ({
    textAlignment,
    className,
    children,
    ...props
  }: TextProps & HTMLAttributes<HTMLHeadingElement>) => (
    <h2
      {...props}
      className={cx(
        'text-3xl md:text-4xl font-semibold text-gray-800 leading-snug',
        textAlignment === 'CENTER' && 'text-center',
        className,
      )}
    >
      {children}
    </h2>
  ),
  H3: ({
    textAlignment,
    className,
    children,
    ...props
  }: TextProps & HTMLAttributes<HTMLHeadingElement>) => (
    <h3
      {...props}
      className={cx(
        'text-2xl md:text-3xl font-semibold text-gray-800 leading-snug',
        textAlignment === 'CENTER' && 'text-center',
        className,
      )}
    >
      {children}
    </h3>
  ),
  H4: ({
    textAlignment,
    className,
    children,
    ...props
  }: TextProps & HTMLAttributes<HTMLHeadingElement>) => (
    <h4
      {...props}
      className={cx(
        'text-xl md:text-2xl font-semibold text-gray-800 leading-snug',
        textAlignment === 'CENTER' && 'text-center',
        className,
      )}
    >
      {children}
    </h4>
  ),
  H5: ({
    textAlignment,
    className,
    children,
    ...props
  }: TextProps & HTMLAttributes<HTMLHeadingElement>) => (
    <h4
      {...props}
      className={cx(
        'text-lg md:text-xl font-semibold text-gray-800 leading-snug',
        textAlignment === 'CENTER' && 'text-center',
        className,
      )}
    >
      {children}
    </h4>
  ),
  H6: ({
    textAlignment,
    className,
    children,
    ...props
  }: TextProps & HTMLAttributes<HTMLHeadingElement>) => (
    <h4
      {...props}
      className={cx(
        'md:text-lg font-medium text-gray-800 leading-snug',
        textAlignment === 'CENTER' && 'text-center',
        className,
      )}
    >
      {children}
    </h4>
  ),
  Body: ({
    textAlignment,
    className,
    children,
    ...props
  }: TextProps & HTMLAttributes<HTMLDivElement>) => (
    <div
      {...props}
      className={cx(
        'text-gray-800 leading-relaxed',
        textAlignment === 'CENTER' && 'text-center',
        className,
      )}
    >
      {children}
    </div>
  ),
  Small: ({
    textAlignment,
    className,
    children,
    ...props
  }: TextProps & HTMLAttributes<HTMLDivElement>) => (
    <div
      {...props}
      className={cx(
        'text-xs md:text-sm text-gray-800',
        textAlignment === 'CENTER' && 'text-center',
        className,
      )}
    >
      {children}
    </div>
  ),
};
